import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://xuvsjdpkdyspjxavhpkg.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh1dnNqZHBrZHlzcGp4YXZocGtnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMxNTI3NzIsImV4cCI6MjA4ODcyODc3Mn0.DkO_rYHGKu2EiKHQD4d-tSamEkLwq6geNP75TJbsdxo'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
